export const GET_KNOWLEDGE_CATEGORIES = "GET_KNOWLEDGE_CATEGORIES";
export const GET_KNOWLEDGE_FILES = "GET_KNOWLEDGE_FILES";
export const SET_KNOWLEDGE_LOADING = "SET_KNOWLEDGE_LOADING";
export const SET_KNOWLEDGE_ERROR = "SET_KNOWLEDGE_ERROR";